import React, {Component} from "react";
import {connect} from "react-redux";
import BackgroundImage from "../../components/BackgroundImage";
import Button from "../../components/Button";
import AuthenticatePayment from "./AuthenticatePayment";
import {reportShowOrderStatusSuccess, cancelShowOrderStatus} from "../../actions/CheckoutApiActions";
import {formatInvoiceNr} from "../../lib/TextFormatter";
import "./PlaceOrderFormContainer.css";

class PlaceOrderFormContainer extends Component {

  render() {
    return (
      <div className="PlaceOrderFormContainer status">        
        {this.renderView(this.props.status)}
      </div>
    )
  }

  renderView(status) {
    switch(status) {
      case "success":
        return <React.Fragment>
                 <BackgroundImage className="featureIcon" src="/images/icon-signup-success.png" width="140px" height="140px" />
                 <h4>Thank You</h4>
                 <p>We have received your order with invoice number {formatInvoiceNr(this.props.invoiceNr)}.</p>
                 <Button label="Continue" primary={true} onClick={this.handleContinue.bind(this)} />
               </React.Fragment>        
      case "error":
        return <React.Fragment>
                 <BackgroundImage className="featureIcon" src="/images/icon-signup-failed.png" width="140px" height="140px" />
                 <h4>Payment Failed</h4>
                 <p>{formatErrorMessage(this.props.errorMsg)}</p>
                 <Button label="Submit" primary={true} onClick={this.handleCancel.bind(this)} />
               </React.Fragment>    
      case "authenticate":
        return <React.Fragment>
                 <BackgroundImage className="featureIcon" src="/images/icon-signup-progress.gif" width="140px" height="140px" />
                 <h4>Standby</h4>
                 <p>Your payment needs to be authorised. A window will popup with instructions to fulfil the payment. When done, the purchase will be verified and the order will be sent.</p>
                 <AuthenticatePayment 
                  accountId={this.props.accountId}
                  orderId={this.props.orderId} 
                  />
               </React.Fragment>            
      case "verifying":
        return <React.Fragment>
                 <BackgroundImage className="featureIcon" src="/images/icon-signup-progress.gif" width="140px" height="140px" />
                 <h4>Standby</h4>
                 <p>Please wait while we are verifying your purchase</p>
                 <AuthenticatePayment 
                  accountId={this.props.accountId}
                  orderId={this.props.orderId} 
                  />
               </React.Fragment>            
      default: 
        return <React.Fragment>
                 <BackgroundImage className="featureIcon" src="/images/icon-signup-progress.gif" width="140px" height="140px" />
                 <h4>Standby</h4>
                 <p>We are placing your order</p>
               </React.Fragment>

    }
  }

  handleContinue() {
    this.props.reportShowOrderStatusSuccess();
  }

  handleCancel() {
    this.props.cancelShowOrderStatus();
  }

}

function formatErrorMessage(msg) {
  switch(msg) {
    case "account_delinquent":
      return "The order could not be made because your billing account is delinquent.";

    default:
      return msg;
  }
}

export default connect(null, {
  reportShowOrderStatusSuccess, 
  cancelShowOrderStatus
})(PlaceOrderFormContainer);